/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 20/11/2021
 */

export let defaultPalette = [
	'#409EFF',
	'#67C23A',
	'#E6A23C',
	'#F56C6C',
	'#909399',
	'#303133',

	'#FF4F03',
	'#B88562',
	'#E55CFF',
	'#8247F5',
	'#0099FF',
	'#09E8F0',
	'#17E885',
	'#CCF002',
	'#F8E436',
	'#FFA603',
	'#658BA8',
	'#969696'
];

// '#a4bdfc',
// '#7ae7bf',
// '#dbadff',
// '#ff887c',
// '#fbd75b',
// '#ffb878',
// '#409EFF',
// '#e1e1e1',
// '#5484ed',
// '#51b749',
// '#dc2127'

let defaultColorPickerPalette = [
	'#039be5',
	'#33B679',
	'#0b8043',
	'#7986CB',
	'#3f51b5',
	'#F6BF26',
	'#e67c73',
	'#f5511d',
	'#d60000',
	'#8E24AA',
	'#616161',
]

let healthConditionColorPickerPalette = [
	'#039be5',
	'#0b8043',
	'#F6BF26',
	'#d60000',
	'#8E24AA',
	'#f4511e',
	'#616161',
	'#00897b',
	'#5e35b1',
	'#c2185b',
	'#7cb342',
	'#6d4c41',
	'#3949ab',
	'#fb8c00',
	'#1e88e5',
	'#43a047',
	'#e53935',
	'#8d6e63',
	'#00acc1',
	'#9e9d24',
]


let expandedColorPickerPalette = [
	// Base Color: #039be5 (Blue)
	'#039be5',
	'#A2D4F4', // Light Blue

	// Base Color: #33B679 (Green)
	'#33B679',
	'#8ADCAB', // Light Green

	// Base Color: #0b8043 (Dark Green)
	'#0b8043',
	'#A1D7B2', // Soft Green

	// Base Color: #7986CB (Soft Blue)
	'#7986CB',
	'#E0E4F2', // Very Light Soft Blue

	// Base Color: #3f51b5 (Indigo)
	'#3f51b5',
	'#C1C6EB', // Light Indigo

	// Base Color: #F6BF26 (Yellow)
	'#F6BF26',
	'#FAD98D', // Light Yellow

	// Base Color: #e67c73 (Red-Pink)
	'#e67c73',
	'#F6DBD8', // Soft Pink

	// Base Color: #f5511d (Orange)
	'#f5511d',
	'#FCCBB9', // Light Orange

	// Base Color: #d60000 (Red)
	'#d60000',
	'#F4A3A3', // Soft Red

	// Base Color: #8E24AA (Purple)
	'#8E24AA',
	'#DCB3E7', // Light Purple

	// Base Color: #616161 (Gray)
	'#616161',
	'#DCDCDC' // Light Gray
]

const editorColorPickerGrayscaleRow = ['#000000', '#434343', '#666666', '#999999', '#b7b7b7', '#cccccc', '#efefef', '#ffffff']
const editorColorPickerBaseRow = ['#e53935', '#fb8c00', '#fdd835', '#43a047', '#1e88e5', '#3949ab', '#8e24aa', '#d500f9']
const editorColorPickerTintLightnessLevels = [84, 72, 60]
const editorColorPickerShadeLightnessLevels = [42, 32, 22]
const editorColorPickerTintSaturationFactors = [0.38, 0.55, 0.72]
const editorColorPickerShadeSaturationFactors = [0.9, 0.82, 0.74]

function toTwoDigitHex(channelValue) {
	return channelValue.toString(16).padStart(2, '0')
}

function hexColorToHsl(hexColor) {
	let normalizedHexColor = hexColor.replace('#', '')
	let red = parseInt(normalizedHexColor.slice(0, 2), 16) / 255
	let green = parseInt(normalizedHexColor.slice(2, 4), 16) / 255
	let blue = parseInt(normalizedHexColor.slice(4, 6), 16) / 255
	let maxChannel = Math.max(red, green, blue)
	let minChannel = Math.min(red, green, blue)
	let lightness = (maxChannel + minChannel) / 2
	let hue = 0
	let saturation = 0
	let delta = maxChannel - minChannel

	if (delta !== 0) {
		saturation = delta / (1 - Math.abs(2 * lightness - 1))

		if (maxChannel === red) {
			hue = 60 * (((green - blue) / delta) % 6)
		}
		if (maxChannel === green) {
			hue = 60 * (((blue - red) / delta) + 2)
		}
		if (maxChannel === blue) {
			hue = 60 * (((red - green) / delta) + 4)
		}
	}

	if (hue < 0) {
		hue += 360
	}

	return {
		hue,
		saturation: saturation * 100,
		lightness: lightness * 100,
	}
}

function hueToRgbChannel(channelP, channelQ, hue) {
	let normalizedHue = hue
	if (normalizedHue < 0) {
		normalizedHue += 1
	}
	if (normalizedHue > 1) {
		normalizedHue -= 1
	}

	if (normalizedHue < 1 / 6) {
		return channelP + (channelQ - channelP) * 6 * normalizedHue
	}
	if (normalizedHue < 1 / 2) {
		return channelQ
	}
	if (normalizedHue < 2 / 3) {
		return channelP + (channelQ - channelP) * (2 / 3 - normalizedHue) * 6
	}
	return channelP
}

function hslToHexColor(hue, saturation, lightness) {
	let normalizedHue = hue / 360
	let normalizedSaturation = saturation / 100
	let normalizedLightness = lightness / 100
	let red = normalizedLightness
	let green = normalizedLightness
	let blue = normalizedLightness

	if (normalizedSaturation !== 0) {
		let channelQ = normalizedLightness < 0.5
			? normalizedLightness * (1 + normalizedSaturation)
			: normalizedLightness + normalizedSaturation - normalizedLightness * normalizedSaturation
		let channelP = 2 * normalizedLightness - channelQ

		red = hueToRgbChannel(channelP, channelQ, normalizedHue + 1 / 3)
		green = hueToRgbChannel(channelP, channelQ, normalizedHue)
		blue = hueToRgbChannel(channelP, channelQ, normalizedHue - 1 / 3)
	}

	return `#${toTwoDigitHex(Math.round(red * 255))}${toTwoDigitHex(Math.round(green * 255))}${toTwoDigitHex(Math.round(blue * 255))}`
}

function createTintColor(hexColor, lightnessLevel, saturationFactor) {
	let {hue, saturation} = hexColorToHsl(hexColor)
	return hslToHexColor(hue, saturation * saturationFactor, lightnessLevel)
}

function createShadeColor(hexColor, lightnessLevel, saturationFactor) {
	let {hue, saturation} = hexColorToHsl(hexColor)
	return hslToHexColor(hue, saturation * saturationFactor, lightnessLevel)
}

let editorColorPickerPalette = [
	editorColorPickerGrayscaleRow,
	editorColorPickerBaseRow,
	...editorColorPickerTintLightnessLevels.map((lightnessLevel, index) => {
		return editorColorPickerBaseRow.map(color => createTintColor(color, lightnessLevel, editorColorPickerTintSaturationFactors[index]))
	}),
	...editorColorPickerShadeLightnessLevels.map((lightnessLevel, index) => {
		return editorColorPickerBaseRow.map(color => createShadeColor(color, lightnessLevel, editorColorPickerShadeSaturationFactors[index]))
	}),
]
// [
// 	'#D50000',
// 	'#E67C73',
// 	'#F4511E',
// 	'#F6BF26',
// 	'#33B679',
// 	'#0B8043',
// 	'#039BE5',
// 	'#3F51B5',
// 	'#7986CB',
// 	'#8E24AA',
// 	'#616161',
//
// 	'#fe4500',
// 	'#F39C19',
// 	// '#ffd700',
// 	'#90ee90',
// 	'#00ced1',
// 	'#1e90ff',
// 	'#c71585',
// 	'#222F3D',
// 	'#BDC3C8',
// 	'#8E43AD'
// ]


const PaletteEnum = Object.freeze({
	COLOR_PICKER_PRIMARY: defaultColorPickerPalette[0],
	PRIMARY: defaultPalette[0],
	SUCCESS: defaultPalette[1],
	WARNING: defaultPalette[2],
	DANGER: defaultPalette[3],
	DISABLED: defaultPalette[4],
	SUCCESS_LIGHT: "#CCF002",
	DEFAULT_STAR_COLOR: "#f7ba2a",
})

export {
	PaletteEnum,
	defaultColorPickerPalette,
	healthConditionColorPickerPalette,
	expandedColorPickerPalette,
	editorColorPickerPalette,
}
